export { default } from './FooterIndicator';
